<template>
    <section class="recent-updates">
        <h3 class="mb-3">Recent Updates</h3>
        <div v-if="!loading">
            <ul class="rows">
                <li v-for="(update, index) in updates" class="row py-2 px-3" :class="{'t-navy': index % 2 === 0, 'bg-white': index % 2 !== 0 }">
                    <div class="row__content d-flex flex-column">
                        <div class="row__heading mb-1">{{formattedDate(update)}}</div>
                        <div class="row__paragraph t-navy">{{title(update)}}</div>
                    </div>
                    <a class="btn btn-ghost btn-small" :href="modelUrl(update)">View</a>
                </li>
            </ul>
        </div>
        <div v-else>
            <div class="content-loader">
                <ContentLoader
                    :height="500"
                    :width="720"
                    :speed="2"
                    primaryColor="#f3f3f3"
                    secondaryColor="#ecebeb"
                >
                    <rect x="0" y="0" rx="0" ry="0" width="720" height="56"/>
                    <rect x="0" y="72" rx="0" ry="0" width="720" height="56"/>
                    <rect x="0" y="144" rx="0" ry="0" width="720" height="56"/>
                    <rect x="0" y="216" rx="0" ry="0" width="720" height="56"/>
                    <rect x="0" y="288" rx="0" ry="0" width="720" height="56"/>
                    <rect x="0" y="360" rx="0" ry="0" width="720" height="56"/>
                    <rect x="0" y="432" rx="0" ry="0" width="720" height="56"/>
                </ContentLoader>
            </div>
        </div>
    </section>
</template>

<script>

    import {axiosApi, axiosWeb} from "@/js/axios";
    import moment from "moment";
    import {ContentLoader} from 'vue-content-loader'
    import {axiosPlatform} from "../axios";

    export default {
        name: "CatUxoRecentUpdates",
        components: {
            ContentLoader,
        },
        data: function () {
            return {
                loading: true,
                updates: []
            }
        },
        computed: {},
        methods: {
            fetchRecentUpdates() {
                let $this = this;
                return axiosPlatform.get(`/updates?page=1`)
                    .then(response => {
                        this.updates = (response.data.data).slice(0,6)
                        this.loading = false
                    })
                    .catch(error => {
                        this.loading = false;
                    })
            },
            title(model) {
                return `${model.member.name} contributed to ${model.hazard.name}`
            },
            formattedDate(model) {
                return model.when
            },
            modelUrl(model) {
                return model.hazard.permalink
            }
        },
        created() {
            this.fetchRecentUpdates();
        },
        mounted() {
        }
    }
</script>

<style lang="scss" scoped>
    @include media-breakpoint-down(md) {
        .recent-updates {
            .row {
                &__content {
                    width: 75%;
                }
            }
        }
    }

    @include media-breakpoint-down(xs) {
        .recent-updates {
            .row {
                display: block;

                &__content {
                    width: 100%;
                    margin-bottom: rem(8px);
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// resources/js/components/RecentUpdates.vue